// Centralized Font Awesome library registration so string icon names work app-wide
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faXmark,
  faBars,
  faUserGear,
  faChevronRight,
  faChevronLeft,
  faRightFromBracket,
  faHouse,
  faTableColumns,
  faUniversalAccess,
  faLock,
  faClipboard,
  faUser,
  faLockOpen,
  faKey,
  faUsers,
  faUsersRectangle,
  faUsersLine,
  faTicket,
  faLink,
  faDoorOpen,
  faBuilding,
  faFaceSadCry,
  faRotate,
  faMagnifyingGlass,
  faEnvelope,
  faFlag,
} from "@fortawesome/free-solid-svg-icons";
import { faTwitter } from "@fortawesome/free-brands-svg-icons";

// Register all icons that are referenced via string names (e.g., icon="xmark")
library.add(
  faXmark,
  faBars,
  faUserGear,
  faChevronRight,
  faChevronLeft,
  faRightFromBracket,
  faHouse,
  faTableColumns,
  faUniversalAccess,
  faLock,
  faClipboard,
  faUser,
  faLockOpen,
  faKey,
  faUsers,
  faUsersRectangle,
  faUsersLine,
  faTicket,
  faLink,
  faDoorOpen,
  faBuilding,
  faFaceSadCry,
  faRotate,
  faMagnifyingGlass,
  faTwitter,
  faEnvelope,
  faFlag,
);
